import posthog from 'posthog-js'
import { forgetStoredPersonalData, scrubUrlQueries } from './posthogPrivacy'
import { ORGANIZATION_PROPERTY } from './analytics'

// RxPad screens show patient health information, and PostHog stores what it
// receives outside Australia (EU region; PostHog has no AU region). This
// config keeps patient and clinician personal data out of it: RXP-2552.
posthog.init(process.env.REACT_APP_VITE_PUBLIC_POSTHOG_KEY || '', {
  api_host: process.env.REACT_APP_VITE_PUBLIC_POSTHOG_HOST || '',
  autocapture: true,
  // Clicked elements are recorded by tag, class and position only. Their text
  // and attributes can be a patient's name or details.
  mask_all_text: true,
  mask_all_element_attributes: true,
  // Replay records the screen. Turned off here so the PostHog project settings
  // cannot turn it back on.
  disable_session_recording: true,
  enable_recording_console_log: false,
  // Both store the landing URL and resend it with every feature-flag request,
  // out of reach of before_send. RxPad does not run campaigns.
  save_referrer: false,
  save_campaign_params: false,
  before_send: scrubUrlQueries,
  loaded: (ph) => {
    forgetStoredPersonalData(ph)
    // Before the first pageview, which would otherwise carry the organisation
    // of whoever used this browser last; the store sets it again on sign-in.
    ph.unregister(ORGANIZATION_PROPERTY)
    window.PH = ph
  },
})

export default posthog
